import apiService from './apiService';
import guestApiService, { clearGuestToken, hasStoredGuestToken } from './guestApiService';

export { hasStoredGuestToken } from './guestApiService';

const guestActionMap = {
	active_emp_list: 'guest_active_emp_list',
	get_emp_available_dates: 'guest_get_emp_available_dates',
	get_emp_available_times: 'guest_get_emp_available_times',
	get_variations: 'guest_get_variations',
	get_service_addons: 'guest_get_service_addons',
	add_temp_booking: 'guest_add_temp_booking',
	add_individual_product: 'guest_add_individual_product',
	get_temp_bookings: 'guest_get_temp_bookings',
	get_checkout_data: 'guest_get_checkout_data',
	validate_promotion_code: 'guest_validate_promotion_code',
	delete_temp_bookings: 'guest_delete_temp_bookings',
	delete_temp_product: 'guest_delete_temp_product',
	delete_cart_items: 'guest_delete_cart_items',
	extend_expire_time: 'guest_extend_expire_time',
	add_order: 'guest_add_order',
};

export const hasCustomerSession = (token) =>
	Boolean(token?.session_key && token?.userrole !== 'ref_agent');

export const shouldUseGuestCart = (token) => {
	return !hasCustomerSession(token) && hasStoredGuestToken();
};

export const toGuestAction = (action) => guestActionMap[action] || action;

export default async function customerOrGuestApiService(
	query,
	token,
	setToken,
	navigate,
	options = {},
) {
	if (hasCustomerSession(token)) {
		return apiService(query, token, setToken, navigate);
	}

	const guestAction = guestActionMap[query.action];
	if (!guestAction) {
		return guestApiService(query, options);
	}

	const response = await guestApiService({ ...query, action: guestAction }, options);
	if (query.action === 'add_order' && response.type?.toLowerCase() === 'success') {
		clearGuestToken();
	}

	return response;
}
